import Utils from './utils';

const FroalaUtils = {

    loadFroalaEditor(sources, froalaKey) {
        if (!window.froalaLoaded) {
            Utils.loadExternalScript(sources.froala).then(() => {
                window.froalaLoaded = true;
                window.$.FroalaEditor.DEFAULTS.key = froalaKey;
                this.loadFroalaEditorPlugins(sources);
            });
        } else {
            this.loadFroalaEditorPlugins(sources);
        }
    },

    loadExternalEditorScripts(sources, froalaKey) {
        if (!window.$ || !window.jQuery) {
            Utils.loadExternalScript(sources.jquery).then(() => {
                this.loadFroalaEditor(sources, froalaKey);
            });
        } else {
            this.loadFroalaEditor(sources, froalaKey);
        }
    },

    loadFroalaEditorPlugins(sources) {
        if (sources.froalaParagraphPlugin && !window.froalaParagraphPluginLoaded) {
            Utils.loadExternalScript(sources.froalaParagraphPlugin).then(() => {
                window.froalaParagraphPluginLoaded = true;
            });
        }

        if (sources.froalaListPlugin && !window.froalaListPluginLoaded) {
            Utils.loadExternalScript(sources.froalaListPlugin).then(() => {
                window.froalaListPluginLoaded = true;
            });
        }

        if (sources.froalaAlignPlugin && !window.froalaAlignPluginLoaded) {
            Utils.loadExternalScript(sources.froalaAlignPlugin).then(() => {
                window.froalaAlignPluginLoaded = true;
            });
        }

        if (sources.froalaCodeViewPlugin && !window.froalaCodeViewPluginLoaded) {
            Utils.loadExternalScript(sources.froalaCodeViewPlugin).then(() => {
                window.froalaCodeViewPluginLoaded = true;
            });
        }

        if (sources.froalaImagePlugin && !window.froalaImagePluginLoaded) {
            Utils.loadExternalScript(sources.froalaImagePlugin).then(() => {
                window.froalaImagePluginLoaded = true;
            });
        }

        if (sources.froalaTablePlugin && !window.froalaTablePluginLoaded) {
            Utils.loadExternalScript(sources.froalaTablePlugin).then(() => {
                window.froalaTablePluginLoaded = true;
            });
        }

        if (sources.froalaLinkPlugin && !window.froalaLinkPluginLoaded) {
            Utils.loadExternalScript(sources.froalaLinkPlugin).then(() => {
                window.froalaLinkPluginLoaded = true;
            });
        }

        // if (sources.froalaInlineClassPlugin && !window.froalaInlineClassPlugin) {
        //     Utils.loadExternalScript(sources.froalaInlineClassPlugin).then(() => {
        //         window.froalaInlineClassPlugin = true;
        //     });
        // }
    }
};

export default FroalaUtils;
